import ChannelSelected from './ChannelSelected'
export default ChannelSelected
